var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuotesSm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.7342,
    cy: 23.7342,
    r: 23.7342,
    fill: "#FC7753"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_546_2157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9641 21.4941C32.9231 23.0355 32.6001 24.5089 31.7697 25.8516C30.7649 27.4802 29.2731 28.5659 27.4225 29.2203C27.2329 29.2881 27.0381 29.3463 26.8433 29.4044C26.4332 29.5256 26.0282 29.3899 25.8026 29.0603C25.5822 28.7404 25.6027 28.3381 25.8744 28.0327C26.1461 27.7274 26.4178 27.422 26.6638 27.0924C27.0791 26.5399 27.4379 25.9582 27.7199 25.3281C27.7711 25.2166 27.7865 25.1778 27.6327 25.1439C25.7206 24.7319 24.357 23.1082 24.3467 21.2372C24.3365 19.3614 25.7001 17.6989 27.6071 17.2626C30.2676 16.6519 32.4925 18.392 32.9026 20.6022C32.9436 20.8979 32.9692 21.1936 32.9641 21.4941Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.137 21.3437C23.1011 22.8027 22.8602 24.0581 22.2707 25.2456C21.3582 27.0874 19.8562 28.3331 17.8877 29.1135C17.6006 29.2298 17.3032 29.3219 17.0008 29.4092C16.5958 29.5207 16.2011 29.3898 15.9704 29.0699C15.7397 28.75 15.7551 28.3525 16.0268 28.0423C16.5087 27.4994 16.97 26.942 17.3443 26.3265C17.5442 26.0017 17.7185 25.6673 17.8774 25.3231C17.9235 25.2213 17.9338 25.1777 17.7903 25.1438C16.0114 24.6979 14.9195 23.6121 14.5658 21.9108C14.1352 19.8363 15.5911 17.7521 17.7646 17.2577C20.379 16.6615 22.5577 18.3337 23.0294 20.4858C23.1165 20.8251 23.1421 21.1595 23.137 21.3437Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_546_2157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.4599,
    height: 12.3066,
    fill: "white",
    transform: "translate(14.5039 17.1411)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotesSm);
export default __webpack_public_path__ + "static/media/quotes_sm.97e1fae56d0b55c97ca9b1cd94f016ba.svg";
export { ForwardRef as ReactComponent };